import { ApplicationStore } from "Types/state";
import { connect } from "react-redux";
import { getAccountFromSlug } from "src/store/dataService/actions/account";
import React, { useEffect, useRef } from "react";
import Electric from "./Electric";
import { useFrame } from "react-frame-component";

const Modes = ({ slug, getAccountData }: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const iframe = useFrame();
    const iframeRef = useRef(iframe);

    useEffect(() => {
        getAccountData(slug, iframeRef.current);
    }, [slug, getAccountData, iframeRef]);

    // payment_calc mode is currently broken due to https://dealerinspire.atlassian.net/browse/ONSHOP-6763
    // if (isAppOpen && mode === "payment_calc") {
    //     return <PaymentCalculator />
    // }

    return <Electric />;
};

const mapStateToProps = ({ account, onlineShopper }: ApplicationStore) => ({
    slug: account.slug,
    loading: account.loading,
    mode: account?.settings?.electric?.mode,
    isAppOpen: onlineShopper.isAppOpen,
});

const mapDispatchToProps = {
    getAccountData: getAccountFromSlug,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modes);
